var _rect, _circle, _path, _circle2, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartTypePieDoughuntIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 3.5,
    fill: "var(--report-widget-icon-fill)",
    stroke: "var(--report-widget-icon-fill)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 9,
    fill: "var(--report-widget-icon-stroke)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 21C30 16.0294 25.9706 12 21 12V21H30Z",
    fill: "#F37321"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 6,
    fill: "var(--report-widget-icon-fill)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 11,
    width: 2,
    height: 5,
    fill: "var(--report-widget-icon-fill)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 20,
    width: 2,
    height: 5,
    transform: "rotate(90 31 20)",
    fill: "var(--report-widget-icon-fill)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTypePieDoughuntIcon);
export default __webpack_public_path__ + "static/media/chart-type-pie-doughunt-icon.0975bdab9c7bf904060be0e73a623025.svg";
export { ForwardRef as ReactComponent };